// extracted by mini-css-extract-plugin
export var center = "project-module--center--oojlc";
export var container = "project-module--container--GR-dY";
export var container_relative = "project-module--container_relative--Q1idi";